import Authorization from "../../generics/authorization";
import { MFE_COMPONENT_IDS } from "../../utils/enums";

const pageProps = {
  componentId: MFE_COMPONENT_IDS.APPLICATION_360 // MFE
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
